import { useHomeSecurity } from '@contexts/HomeSecurityContext/HomeSecurityContext';
import { Icon } from '@design-system';
import { useEffect, useMemo, useState } from 'react';
import { BsClipboard2CheckFill, BsConeStriped } from 'react-icons/bs';
import { FaBalanceScaleRight, FaBookOpen } from 'react-icons/fa';
import { FaHelmetSafety } from 'react-icons/fa6';
import { useNavigate } from 'react-router-dom';
import { HomeSecurityStep } from '../useHomeSecurityEmargementVM';

export const useHomeSecurityMenuPageVM = () => {
    const { passedModules, worksiteId } = useHomeSecurity();

    const navigate = useNavigate();

    useEffect(() => {
        if (!worksiteId) {
            navigate('/sante-securite/home-security');
        }
    }, [worksiteId, navigate]);

    const [steps] = useState<HomeSecurityStep[]>([
        {
            title: 'Documents de sécurité',
            icon: <Icon icon={<FaBookOpen />} size={24} color="green" />,
            onClick: () => navigate('/sante-securite/home-security/tools'),
            isDone: passedModules.includes('tools')
        },
        {
            title: 'Présentation du chantier',
            icon: <Icon icon={<BsConeStriped />} size={24} color="green" />,
            onClick: () => navigate('/sante-securite/home-security/worksite-presentation'),
            isDone: passedModules.includes('worksite-presentation')
        },
        {
            title: 'Port obligatoire des EPIs',
            icon: <Icon icon={<FaHelmetSafety />} size={24} color="green" />,
            onClick: () => navigate('/sante-securite/home-security/epis'),
            isDone: passedModules.includes('epis')
        },
        {
            title: 'Formation au poste de travail',
            icon: <Icon icon={<BsClipboard2CheckFill />} size={24} color="green" />,
            onClick: () => navigate('/sante-securite/home-security/formation'),
            isDone: passedModules.includes('formation')
        },
        {
            title: "Droit d'alerte et de retrait",
            icon: <Icon icon={<FaBalanceScaleRight />} size={24} color="green" />,
            onClick: () => navigate('/sante-securite/home-security/withdrawal'),
            isDone: passedModules.includes('withdrawal')
        }
    ]);

    const handleNextStep = () => {
        navigate('/sante-securite/home-security/emargement');
    };

    const hasCompletedAllSteps = useMemo(() => steps.every((step) => step.isDone), [steps]);

    return { steps, hasCompletedAllSteps, handleNextStep };
};
